<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer000">
<p class="Book-Title">Bears</p>
</div>
<div class="Basic-Text-Frame" id="_idContainer001">
<p class="Book-subtitle">The Mighty Grizzlies <em class="booksubitalic _idGenCharOverride-1">of the </em>West</p>
</div>
<div class="Basic-Text-Frame" id="_idContainer002">
<p class="author">Julie Argyle</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer003">
<img alt="Photo of logo." class="_idGenObjectAttribute-1" src="image/logo.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer004">
<img alt="Photo of bear." class="_idGenObjectAttribute-1" src="image/176A9232-29a-DeNoiseAI-low-lightNWM.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer005">
<img alt="Photo of trees." class="_idGenObjectAttribute-1" src="image/002.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer007">
<p class="dedication">For the love of the grizzly. <br/>This book is dedicated to
				Raspberry.</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer006">
<img alt="Photo of outdoor scenery." class="_idGenObjectAttribute-2" src="image/IMG_3527_P.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer008">
<img alt="Photo of bear." class="_idGenObjectAttribute-1" src="image/_76A4507.jpg"/>
</div>
</div>
<div class="pagebreak">
<div epub:type="toc" id="_idContainer009">
<p class="contents">Contents</p>
<p class="TOC">
<a href="#/00_Bears#_idTextAnchor000">Foreword</a>
</p>
<p class="TOC">
<a href="#/00_Bears#_idTextAnchor001">Introduction</a>
</p>
<p class="TOC">
<span href="#/01_Bears#_idTextAnchor002" title="Link target outside of Sample">Relationship with Native Americans</span>
</p>
<p class="TOC">
<span href="#/02_Bears_Endagered_Species_Act#_idTextAnchor003" title="Link target outside of Sample">The Endangered
					Species Act</span>
</p>
<p class="TOC">
<span href="#/03_Bears_Hibernation#_idTextAnchor004" title="Link target outside of Sample">Hibernation</span>
</p>
<p class="TOC">
<span href="#/04_Bears_Raspberry#_idTextAnchor005" title="Link target outside of Sample">A Bear Called Raspberry</span>
</p>
<p class="TOC">
<span href="#/05_Bears_Bear_791#_idTextAnchor006" title="Link target outside of Sample">Grizzly 791</span>
</p>
<p class="TOC">
<span href="#/06_Bears_Snow#_idTextAnchor007" title="Link target outside of Sample">Along Came Snow</span>
</p>
<p class="TOC">
<span href="#/07_Bears_Snaggletooth#_idTextAnchor008" title="Link target outside of Sample">Snaggletooth</span>
</p>
<p class="TOC">
<span href="#/08_Bears_Obsidian#_idTextAnchor010" title="Link target outside of Sample">The Obsidian Sow</span>
</p>
<p class="TOC">
<span href="#/09_Bears_back#_idTextAnchor011" title="Link target outside of Sample">Closing</span>
</p>
<p class="TOC">
<span href="#/09_Bears_back#_idTextAnchor012" title="Link target outside of Sample">Resources </span>
</p>
<p class="TOC">
<span href="#/09_Bears_back#_idTextAnchor014" title="Link target outside of Sample">Acknowledgments </span>
</p>
</div>
<div class="Basic-Text-Frame" id="_idContainer010">
<p class="quote-lrg">Bears are not companions of men, but children of God, and His
				charity is broad enough for both. </p>
<p class="quote-author-sm">—John Muir</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer011">
<img alt="Photo of bear." class="_idGenObjectAttribute-3" src="image/157_P2.jpg"/>
</div>
</div>
<div class="pagebreak">
<div class="Basic-Text-Frame" id="_idContainer012">
<h1 class="ct-FM" id="_idParaDest-1"><a id="_idTextAnchor000">Foreword</a></h1><a id="_idTextAnchor000">
<p class="Txt1">Vóhpahtse-náhkohe, or “white-mouthed bear,” is what my Native American
				friend calls them, not grizzly bears. The fact his people named this bear for the
				saliva produced around its mouth when agitated, and not for the silvery, grizzled
				tips of its outer guard hairs as seen from a distance, speaks to their intimate
				interactions with the great bear. The Cheyenne, Crow, Lakota, Blackfeet, and First
				Nation’s peoples around the world have not only coexisted in reverence with the
				grizzly bear, but sought them out as wise grandfathers and keepers of a very sacred,
				healing medicine—some of the most powerful among shamans. </p>
<p class="Txt">So when I went to work on a grizzly bear film with fellow advocate and
				friend, Doug Peacock, one of the first people we reached out to was our Native
				friend who works with tribes across North America. I asked him if there was any
				opportunity to film, and/or sit in on a grizzly bear ceremony, somewhere within a
				day’s drive of my home in Montana. </p>
<p class="Txt">He told me that once the grizzly bear was harassed, murdered, and
				eventually driven to the most remote and desolate regions of the American West, not
				unlike indigenous cultures, the sacred relationship between the two was disrupted.
				That when the grizzly bear began to disappear off of the physical landscape, and
				holy men with grizzly bear medicine moved on to the next world, there was no one to
				pass the eons old knowledge to. He told me that sadly, once the grizzly was
				exterminated, the medicine and ceremonies usually went with it. There was a great
				heaviness between us. </p>
<p class="Txt">We have more at stake than just the survival of an animal species. I
				believe that whatever happens to the grizzly bear will eventually befall humans. The
				two are that connected. For when we lose the ability to appreciate the intricacies
				of coexistence, and compassion for another five-toed sentient being trying to find
				its way in this world too, we lose that luminous fiber that connects us all, and
				become slightly less human. </p>
<p class="Txt">I used to tell people that grizzly bears saved my life after immeasurable
				tragedy, so I felt an obligation to protect them. My friend, and poet, CMarie
				Fuhrman summed it up a little better. She offered that “grizzly bears didn’t save my
				life, I saved my life, grizzly bears just showed me why.” I like that better. </p>
<p class="Txt">The following stories are told from a place of love and respect for two
				species I hold dear: humans and grizzlies. Enjoy every word.</p>
<p class="Txt2">For the grizzly inside us all,</p>
<p class="Txt3">— Brad Orsted</p>
<p class="Txt4">Wildlife Photographer</p>
</a></div><a id="_idTextAnchor000">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer013">
<img alt="Photo of bear." class="_idGenObjectAttribute-1" src="image/_76A8734-1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer014">
<img alt="Photo of bear." class="_idGenObjectAttribute-1" src="image/357_P.jpg"/>
</div>
</div>
</a><div class="pagebreak"><a id="_idTextAnchor000">
</a><div id="_idContainer015"><a id="_idTextAnchor000">
</a><h1 class="ct-FM" id="_idParaDest-2"><a id="_idTextAnchor000"></a><a id="_idTextAnchor001">Introduction</a></h1><a id="_idTextAnchor001">
<p class="Txt1"><span class="LEDE _idGenCharOverride-1">As the snow starts to melt and
					springtime arrives in the Rockies,</span> many people like me find themselves
				dreaming not only about the beauty of the wild places you can visit, but also about
				the wild animals who inhabit those places. It’s at this time when I start thinking
				about the mighty grizzly, and wondering what kind of year I am going to have when
				I’m out with my camera and shooting photos. </p>
<p class="Txt">As a young girl, I remember traveling to Yellowstone with my family in
				hopes of seeing one of these magical bears. Back then we considered ourselves lucky
				if in a time frame of ten days we were able to see just one, and when we did finally
				come across one, it was the highlight of our trip. We would then spend as much time
				as we could watching it. It didn’t matter if the bear was hundreds of yards away and
				looked like an ant on the horizon, we were always in awe and stayed until it
				disappeared out of sight. </p>
<p class="Txt">As the years went by, my love for this incredible species grew and I
				found myself drawn in their direction more than ever. I started visiting Yellowstone
				more often, hoping to catch a glance and watch them in their natural habitat. I
				wanted to see sows and cubs as they interacted, and to watch as the big boars made
				their presence known. I wanted to know what it meant to be a grizzly living in the
				wild.</p>
<p class="Txt">The memories I have made over the years are priceless. I remember when
				the Fishing Bridge campground was located across from the Fishing Bridge store
				rather than where it is now. It always seemed like a very eerie place to stay.
				Whether it was daytime or nighttime, I remember thinking that every noise was a bear
				coming to carry me away. Eventually that campground was closed and the new one was
				built. That area was given back to the grizzlies because it was considered their
				passage as they traveled to and from Yellowstone Lake.</p>
<p class="Txt">At one point in time, there was a grizzly that learned how to get into
				the bear-proof garbage cans. It would use one paw and stick its claws underneath the
				handle and open it up and then use the other paw to reach down in and get the
				garbage out. I’m not sure whatever happened to that bear. I remember them
				setting a trap for it, but never heard the outcome.</p>
<p class="Txt">I also remember a small ranger station or warming hut that was located
				right by the entrance of that first Fishing Bridge campground. We would often stop
				in there and ask if there were any recent bear sightings. If there were, we hoped
				that we could make it to the destination before the bear disappeared into the
				landscape.</p>
<p class="Txt">Speaking of landscapes, Yellowstone is such a beautiful place for a
				grizzly to wander. The amazing sunrises and sunsets, not to mention the mountains
				and valleys, the rivers, the wildflowers, the pines, and all of the smells that go
				along with them—what an incredible place to call home.</p>
<p class="Txt">I’ve watched grizzlies swim and fish in the lake, take down another
				animal for food, fight another bear, chase wolves, play on a patch of snow, and
				sleep on a log. I’ve watched sows and boars mate, cubs hug their mom, and many other
				wonderful sights. There is no better way to learn about this type of nature than to
				experience it firsthand. Thankfully I have been able to observe many of the things I
				always dreamed about. </p>
<p class="Txt">I hope you enjoy this book as much as I have enjoyed spending so much
				time in the wilderness. </p>
</a></div><a id="_idTextAnchor001">
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer016">
<img alt="Photo of bear." class="_idGenObjectAttribute-1" src="image/301a5x7.jpg"/>
</div>
</div>
</a></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00_Bears.vue?522966e5